import {Box} from '@chakra-ui/react';

export const WidgetBoxWrapper: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <Box
      color="darkGrey"
      backgroundColor="superlight"
      borderRadius={{base: '0', sm: '8px'}}
    >
      <Box maxWidth="375px" margin="0 auto">
        {props.children}
      </Box>
    </Box>
  );
};
